import { getHeaders } from '../../core/actions/xhrRequest';
import { createAction } from 'redux-api-middleware';

export const FETCH_BALANCE_INFO_INIT = 'FETCH_BALANCE_INFO_INIT';
export const FETCH_BALANCE_INFO_SUCCESS = 'FETCH_BALANCE_INFO_SUCCESS';
export const FETCH_BALANCE_INFO_FAILURE = 'FETCH_BALANCE_INFO_FAILURE';

export const fetchBalanceInfo = () => createAction({
    types: [
        FETCH_BALANCE_INFO_INIT,
        FETCH_BALANCE_INFO_SUCCESS,
        FETCH_BALANCE_INFO_FAILURE
    ],
    endpoint: '/api/balance/view',
    headers: getHeaders(),
    method: 'GET',
    credentials: 'include'
});